import { computed } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

export const useUserCompany = () => {
  const { useGetters } = createVuexHelpers()
  const { user } = useGetters(['user'])

  const id = computed(() => {
    const { company } = user.value || {}

    return !!company ? company.id : undefined
  })

  const roleId = computed(() => {
    const { company } = user.value || {}

    if (!!company) {
      return company.role.id || null
    } else {
      return null
    }
  })

  const roleName = computed(() => {
    const { is_superuser, company } = user.value || {}

    if (is_superuser) {
      return 'admin'
    } else if (!!company) {
      return company.role.role || null
    } else {
      return null
    }
  })

  const roleValue = computed(() => {
    const { is_superuser, company } = user.value || {}

    if (is_superuser) {
      return 'admin'
    } else if (!!company) {
      return company.role_value || null
    } else {
      return null
    }
  })

  const isRoleName = (checkRoleName) => checkRoleName === roleName.value

  return {
    id,

    roleId,
    roleName,
    roleValue,

    isRoleName
  }
}
